export default __webpack_public_path__ + "static/headerBackgroundMobile-99247c9ea4f13526c1e19bbc7f53c36b.png";